/* unplugin-vue-components disabled */import { render } from "./rankDetail.vue?vue&type=template&id=3c118274&scoped=true&ts=true"
import script from "./rankDetail.vue?vue&type=script&lang=ts"
export * from "./rankDetail.vue?vue&type=script&lang=ts"

import "./rankDetail.vue?vue&type=style&index=0&id=3c118274&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c118274"]])

export default __exports__